// REACT
import React, { Component } from 'react';

// STYLING
import styled from 'styled-components';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import H3 from '../../../components/Primatives/H3';
import TimePicker from './TimePicker';

const StyledForm = styled.div`
    background-color: white;
    color: #3fa9b4;
    width: 250px;
    height: 175px;
    text-align: center;
    padding: 1%;
`;

const StyledFormComponent = ({
    addEditAvailability,
    grabEndTime,
    grabStartTime,
    formName,
    formMessage
}) => {  
    const checkForValidTimes = (e) => {
        e.preventDefault();
        addEditAvailability(e.target.name);
    };
    

        return (
            <StyledForm>
                <form onSubmit={checkForValidTimes} name={formName} >
                    <div className="control">
                        <div>
                            <H3 style={{ display: "inline-block", marginRight: 10 }}>Start:</H3>
                            <select name="startTime" id="startTime" onChange={grabStartTime} required defaultValue="Choose start time">
                                <option value="Choose start time" disabled hidden>Choose start time</option>
                                <TimePicker/>
                            </select>
                        </div>
                        <div>
                            <H3 style={{ display: "inline-block", marginRight: 10 }}>End:</H3>
                            <select name="endTime" id="endTime" onChange={grabEndTime} required defaultValue="Choose end time">
                                <option value="Choose end time" disabled hidden>Choose end time</option>
                                <TimePicker/>
                            </select>
                        </div>
                    </div>
                    <br/>
                    <button 
                            type="submit"
                            style={{
                                backgroundColor: "#3fa9b4",
                                color: "white",
                                borderRadius: "15px",
                                borderStyle: "none",
                                padding: "3%",
                            }}
                    >
                        {formMessage}
                    </button>
                </form>
            </StyledForm>
        );
};

export default StyledFormComponent;


// WEBPACK FOOTER //
// ./src/js/containers/ProviderContainer/components/StyledFormComponent.jsx